/**
 * Cache individual transactions from the txn history api request so they can be used in txndetails component
 * @name cacheEachTxnFromList
 * @param {Array.<Transaction>} txns
 * @param {QueryClient} queryClient
 */
export const cacheEachTxnFromList = (txns, queryClient) => {
  if (txns.length > 0 && queryClient) {
    txns.forEach((txn) => {
      const { transaction_id } = txn;
      queryClient.setQueryData(["transactions", "details", transaction_id], { payload: txn }); // needs to match what's needed in the api response payload for individual txn so storing as payload
    });
  }
};
